import * as React from "react";

const Cart: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g id="Icons/Global/Cart">
                <path id="Subtract" fillRule="evenodd" clipRule="evenodd" d="M6 5C4.89543 5 4 5.89543 4 7C4 8.10457 4.89543 9 6 9H9V25V27V32V34C9 35.1046 9.89543 36 11 36H37C38.1046 36 39 35.1046 39 34C39 32.8954 38.1046 32 37 32H13V27H33C36.3137 27 39 24.3137 39 21V7H13C13 5.89543 12.1046 5 11 5H6ZM17 41C17 43.2091 15.2091 45 13 45C10.7909 45 9 43.2091 9 41C9 38.7909 10.7909 37 13 37C15.2091 37 17 38.7909 17 41ZM39 41C39 43.2091 37.2091 45 35 45C32.7909 45 31 43.2091 31 41C31 38.7909 32.7909 37 35 37C37.2091 37 39 38.7909 39 41ZM13 11H17V16H13V11ZM13 18H17V23H13V18ZM23 11H19V16H23V11ZM19 18H23V23H19V18ZM29 11H25V16H29V11ZM25 18H29V23H25V18ZM35 11H31V16H35V11ZM31 18H35V21C35 22.1046 34.1046 23 33 23H31V18Z" fill="currentColor"/>
            </g>
        </svg>

    );
};

export default React.memo(Cart);
